export const NETWORK_CONDITION = {
  UNKNOWN: 'unknown',
  CRITICAL: 'critical',
  WARNING: 'warning',
  FAIR: 'fair',
  GOOD: 'good',
  EXCELLENT: 'excellent',
};

export const NETWORK_CONDITION_CODE = {
  UNKNOWN: 0,
  CRITICAL: 1,
  WARNING: 2,
  FAIR: 3,
  GOOD: 4,
  EXCELLENT: 5,
};

export const NETWORK_CONDITION_TO_CODE = {
  [NETWORK_CONDITION.UNKNOWN]: NETWORK_CONDITION_CODE.UNKNOWN,
  [NETWORK_CONDITION.CRITICAL]: NETWORK_CONDITION_CODE.CRITICAL,
  [NETWORK_CONDITION.WARNING]: NETWORK_CONDITION_CODE.WARNING,
  [NETWORK_CONDITION.FAIR]: NETWORK_CONDITION_CODE.FAIR,
  [NETWORK_CONDITION.GOOD]: NETWORK_CONDITION_CODE.GOOD,
  [NETWORK_CONDITION.EXCELLENT]: NETWORK_CONDITION_CODE.EXCELLENT,
};

export const CODE_TO_NETWORK_CONDITION = {
  [NETWORK_CONDITION_CODE.UNKNOWN]: NETWORK_CONDITION.UNKNOWN,
  [NETWORK_CONDITION_CODE.CRITICAL]: NETWORK_CONDITION.CRITICAL,
  [NETWORK_CONDITION_CODE.WARNING]: NETWORK_CONDITION.WARNING,
  [NETWORK_CONDITION_CODE.FAIR]: NETWORK_CONDITION.FAIR,
  [NETWORK_CONDITION_CODE.GOOD]: NETWORK_CONDITION.GOOD,
  [NETWORK_CONDITION_CODE.EXCELLENT]: NETWORK_CONDITION.EXCELLENT,
};

export const NETWORK_CONDITION_REASON = {
  NONE: 'none',
  UNKNOWN: 'unknown',
  BANDWIDTH: 'bandwidth',
  PACKET_LOSS: 'packetLoss',
};

export const NETWORK_CONDITION_SOURCE = {
  NONE: 'none',
  BOTH_OR_UNCLEAR: 'bothOrUnclear',
  LOCAL: 'local',
  REMOTE: 'remote',
};
